import { GET_COVERAGES, GET_OPTIONS_BY_BENEFIT_CODE } from 'graphql/queries';
import { client } from '../ApolloProvider';

export const fetchCoverages = async (lang) => {

    const { data, errors } = await client.query({
        query: GET_COVERAGES,
        variables: { language: lang }
    });

    if (errors) throw new Error(errors[0].message);
    return data;
};

export const fetchBenefitByCode = async (codeBenefit, lang) => {

    const { data, errors } = await client.query({
        query: GET_OPTIONS_BY_BENEFIT_CODE,
        variables: { language: lang, benefitCode: codeBenefit }
    });

    if (errors) throw new Error(errors[0].message);
    return data;
};
